import { render, staticRenderFns } from "./RelationCreated.vue?vue&type=template&id=2e7199ec"
import script from "./RelationCreated.vue?vue&type=script&lang=js"
export * from "./RelationCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports